import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "container-xl" };
const _hoisted_2 = { class: "table-responsive" };
const _hoisted_3 = { class: "table-wrapper" };
const _hoisted_4 = { class: "table-title" };
const _hoisted_5 = { class: "row" };
const _hoisted_6 = {
    key: 0,
    class: "table table-striped table-hover"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Id"),
        /*#__PURE__*/ _createElementVNode("th", { class: "big_td" }, "Title"),
        /*#__PURE__*/ _createElementVNode("th", null, "Actions")
    ])
], -1);
const _hoisted_8 = { class: "big_td" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                            _createTextVNode("Manage "),
                            _createElementVNode("b", null, _toDisplayString(_ctx.title), 1)
                        ])
                    ])
                ]),
                (_ctx.checkTitle())
                    ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: item.id
                                }, [
                                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                                    _createElementVNode("td", _hoisted_8, _toDisplayString(item.title), 1),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("button", {
                                            onClick: ($event) => (_ctx.editItem(item)),
                                            class: "fa fa-edit",
                                            "data-toggle": "modal"
                                        }, null, 8, _hoisted_9),
                                        _createElementVNode("button", {
                                            onClick: ($event) => (_ctx.removeItem(item)),
                                            class: "fa fa-remove",
                                            "data-toggle": "modal"
                                        }, null, 8, _hoisted_10)
                                    ])
                                ]));
                            }), 128))
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ])
        ])
    ]));
}
